import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function EditDrug() {

  const {id}=useParams();
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [manus,setManus] = useState([]);
  const [dists,setDists] = useState([]);
  const [registerFormData, setRegisterFormData] = useState({
        "manu":'',
        "dist":'',
        "hsn":'',
        "product":'',
        "pack":'',
        "totqty":'',
        "batch":'',
        "expiry":'',
        "type":'',
        "mrp":'',
        "pprice":'',
        "sgst":'',
        "cgst":'',
        "uamount":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'update-pharm-qty/'+id+'/')
            .then(function (response) {
                setRegisterFormData({
                    manu:response.data.manu?.id,
                    dist:response.data.dist?.id,
                    product:response.data.product,
                    batch:response.data.batch,
                    expiry:response.data.expiry,
                    sgst:response.data.sgst,
                    uamount:response.data.uamount,
                    pack:response.data.pack,
                    totqty:response.data.totqty,
                    hsn:response.data.hsn,
                    mrp:response.data.mrp,
                    pprice:response.data.pprice,
                    type:response.data.type,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);
   useEffect(() => {
        try{
            axios.get(baseUrl+'add-manufacturer/')
            .then(function (response) {
                setManus(response.data);
            });
        }catch(error){
            console.log(error);
        }
        try{
            axios.get(baseUrl+'add-distributor/')
            .then(function (response) {
                setDists(response.data);
            });
        }catch(error){
            console.log(error);
        }
        },[]);

   const handleChange = (event) => {
      setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        });
    };
    const calculateDeduction = () => {
    const { pack, mrp } = registerFormData;
    const packs = registerFormData.pack;
    const mrps = registerFormData.mrp;
    const uamount = (parseFloat(mrps) / parseFloat(packs)).toFixed(2);
    setRegisterFormData((prevState) => ({
      ...prevState,
      uamount,
    }));
  };
  useEffect(() => {
    if (registerFormData.pack !== '') {
      calculateDeduction();
    }
  }, [registerFormData]);

  const submitHandler = (e) => {
     e.preventDefault();
        const manu = document.getElementById("manu").value;
        const dist = document.getElementById("dist").value;

        const formData = new FormData();
        formData.append('product',registerFormData.product);
        formData.append('batch',registerFormData.batch);
        formData.append('expiry',registerFormData.expiry);
        formData.append('sgst',registerFormData.sgst);
        formData.append('cgst',registerFormData.sgst);
        formData.append('hsn',registerFormData.hsn);
        formData.append('type',registerFormData.type);
        formData.append('pack',registerFormData.pack);
        formData.append('totqty',registerFormData.totqty);
        formData.append('mrp',registerFormData.mrp);
        formData.append('pprice',registerFormData.pprice);
        formData.append('uamount',registerFormData.uamount);
        formData.append('manu',manu);
        formData.append('dist',dist);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'update-pharm-qty/'+id+'/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Drug has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/drug-list/';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add drug. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Edit Drug</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="manu" className="form-label">Manufacturer</label>
                        <select name="manu" id="manu"  value={registerFormData?.manu} onChange={handleChange} className="form-control">
                                {manus.map((manuf,index) => {return <option key={index} value={manuf?.id}>{manuf.name}
                                </option>})}
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                        <label htmlFor="dist" className="form-label">Distributor</label>
                        <select name="dist" id="dist" value={registerFormData?.dist} onChange={handleChange} className="form-control">
                            {dists.map((distr,index) => {return <option key={index} value={distr.id}>{distr.name}
                            </option>})}
                        </select>
                        </div>
                        <div className="col-md-5 mb-3">
                        <label htmlFor="product" className="form-label">Drug Name</label>
                            <input type="text" placeholder="Drug Name" className="form-control"
                               name="product" value={registerFormData.product} onChange={handleChange} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="HSN" className="form-label">HSN</label>
                            <input type="text" placeholder="batch" className="form-control"
                               name="hsn" value={registerFormData.hsn} onChange={handleChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="batch" className="form-label">Batch</label>
                            <input type="text" placeholder="batch" className="form-control"
                               name="batch" value={registerFormData.batch} onChange={handleChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="expiry" className="form-label">Expiry</label>
                            <input type="text" placeholder="expiry" className="form-control"
                               name="expiry" value={registerFormData.expiry} onChange={handleChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="type" className="form-label">Type</label>
                            <input type="text" placeholder="Type" className="form-control"
                               name="type" value={registerFormData.type} onChange={handleChange} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-2 mb-3">
                            <label htmlFor="pack" className="form-label">Pack</label>
                            <input type="number" maxLength={10} placeholder="Pack" className="form-control"
                                name="pack" value={registerFormData.pack} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="TQty" className="form-label">TQty</label>
                            <input type="number" maxLength={10} placeholder="TQty" className="form-control"
                                name="totqty" value={registerFormData.totqty} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="MRP" className="form-label">MRP</label>
                            <input type="number" maxLength={10} placeholder="MRP" className="form-control"
                                name="mrp" value={registerFormData.mrp} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="P.Price" className="form-label">Pur.Price</label>
                            <input type="number" maxLength={10} placeholder="Pur.Price" className="form-control"
                                name="pprice" value={registerFormData.pprice} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="SGST" className="form-label">SGST</label>
                            <input type="number" maxLength={10} placeholder="SGST" className="form-control"
                                name="sgst" value={registerFormData.sgst} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="totqty" className="form-label">Unit Amount</label>
                            <input type="number" maxLength={10} placeholder="U Amount" className="form-control"
                                name="uamount" value={registerFormData.uamount} onChange={handleChange} />
                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Update</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default EditDrug;
